import * as Sentry from '@sentry/react';
import _isEmpty from 'lodash/isEmpty';
import _isPlainObject from 'lodash/isPlainObject';

/**
 * @param {Error} error
 * @param {object} extra
 */
export default function logError(error, extra) {
  if (process.env.REACT_APP_MODE === 'DEVELOPMENT') {
    console.log('Log Error: ', error);
  }

  if (_isPlainObject(extra) && !_isEmpty(extra)) {
    Sentry.captureException(error, { extra });
  } else {
    Sentry.captureException(error);
  }
}
